import React, { useState } from 'react';
import styled from 'styled-components';
import { APP_URL } from 'constants/index';
import { Nav } from './components/Nav';
import { Burger } from './components/Burger';
import media from 'constants/styles/media';
import colors from 'constants/styles/colors';
import { MobileNav } from './components/MobileNav';
import { zIndex } from 'constants/styles/z-index';
import layout from 'constants/styles/layout';
import logoUrl from '../../images/svg/logo.svg';
import accountIcon from '../../images/svg/account.svg';

const SHeader = styled.header`
    top: 0;
    left: 0;
    height: ${layout.headerHeight};
    width: 100%;
    z-index: ${zIndex.navigationHeader};
    position: fixed;
    background: ${colors.gray_90};
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: ${media.desktop}) {
        justify-content: flex-start;
        height: ${layout.headerHeightMobile};
    }
`;

const SWrapper = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: ${layout.contentMaxWidth};
    padding: ${layout.contentSpacing};
`;

const SLink = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const SMobileButtons = styled.div`
    display: flex;
    align-items: center;
    gap: 26px;
    @media (min-width: ${media.desktop}) {
        display: none;
    }
`;

interface Props {
    siteTitle: string;
}

export const Navigation = ({ siteTitle }: Props) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleMobileNavOpen = () => setIsOpen(!isOpen);

    return (
        <SHeader>
            <SWrapper>
                <img src={logoUrl} alt={siteTitle} />
                <SMobileButtons>
                    <SLink href={`${APP_URL}/login`} aria-label="Login" title="Login">
                        <img src={accountIcon} alt="" aria-hidden="true" />
                    </SLink>
                    <Burger onClick={handleMobileNavOpen} isOpen={isOpen} />
                </SMobileButtons>
                <Nav />
            </SWrapper>
            {isOpen && <MobileNav onClick={handleMobileNavOpen} />}
        </SHeader>
    );
};
